export default __webpack_public_path__ + "static/media/traveler-inside-train-1x.3a1c213f.webp";